import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ClockIcon, XCircleIcon, ShieldAlertIcon } from 'lucide-react';
export function PainSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  return <section className="py-24 px-4 bg-cream relative" data-id="element-117">
      <div className="max-w-4xl mx-auto" data-id="element-118">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-119">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-warm-900 mb-6 leading-tight" data-id="element-120">
            ¿Tu casa se convierte en una <br className="hidden md:block" data-id="element-121" />
            <span className="italic text-gold-dark" data-id="element-122">"zona de guerra"</span> a
            las 7:00 PM?
          </h2>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} className="space-y-6 mb-16" data-id="element-123">
          <motion.div variants={itemVariants} className="flex items-start gap-4 bg-white p-6 rounded-2xl shadow-sm border border-warm-100" data-id="element-124">
            <div className="bg-warm-50 p-3 rounded-full text-gold-dark shrink-0 mt-1" data-id="element-125">
              <ClockIcon className="w-6 h-6" data-id="element-126" />
            </div>
            <p className="text-lg md:text-xl text-warm-800 leading-relaxed" data-id="element-127">
              Llegas agotada del trabajo a una{' '}
              <strong className="font-semibold" data-id="element-128">
                segunda jornada de gritos
              </strong>
              .
            </p>
          </motion.div>

          <motion.div variants={itemVariants} className="flex items-start gap-4 bg-white p-6 rounded-2xl shadow-sm border border-warm-100" data-id="element-129">
            <div className="bg-warm-50 p-3 rounded-full text-gold-dark shrink-0 mt-1" data-id="element-130">
              <XCircleIcon className="w-6 h-6" data-id="element-131" />
            </div>
            <p className="text-lg md:text-xl text-warm-800 leading-relaxed" data-id="element-132">
              Tu hijo rechaza la comida y la hora de dormir{' '}
              <strong className="font-semibold" data-id="element-133">se extiende por horas</strong>.
            </p>
          </motion.div>

          <motion.div variants={itemVariants} className="flex items-start gap-4 bg-white p-6 rounded-2xl shadow-sm border border-warm-100" data-id="element-134">
            <div className="bg-warm-50 p-3 rounded-full text-gold-dark shrink-0 mt-1" data-id="element-135">
              <ShieldAlertIcon className="w-6 h-6" data-id="element-136" />
            </div>
            <p className="text-lg md:text-xl text-warm-800 leading-relaxed" data-id="element-137">
              Sientes que has{' '}
              <strong className="font-semibold" data-id="element-138">perdido el control</strong> de
              tu paz y de tu tiempo.
            </p>
          </motion.div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-center" data-id="element-139">
          <p className="text-2xl md:text-3xl font-heading font-bold text-warm-900 mb-4" data-id="element-140">
            No estás sola.
          </p>
          <p className="text-lg text-warm-800/80 max-w-2xl mx-auto" data-id="element-141">
            La mayoría de los padres están peleando contra el momento más
            caótico del día.
          </p>
        </motion.div>
      </div>
    </section>;
}